export default {
  meta: {
    title: '忘记密码',
    urlName: '忘记密码' // 埋点字段，上报归属的模块
  }
};
